import script from "./baike.vue?vue&type=script&setup=true&lang=js"
export * from "./baike.vue?vue&type=script&setup=true&lang=js"

import "./baike.vue?vue&type=style&index=0&id=0813b928&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0813b928"]])

export default __exports__